import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 13/16;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 13 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Tasks" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Tasks-kanban-change-default" transform="translate(-954.000000, -24.000000)" fill={color} fillRule="nonzero">
                <g id="Group-17-Copy" transform="translate(940.000000, 11.000000)">
                    <path d="M20.8765772,15.8579411 L16.538339,20.911236 L18.6585721,20.911236 C19.0647197,20.911236 19.3938209,21.2423744 19.3936417,21.6474687 L19.3920603,25.2224918 L23.7361156,20.1739164 L21.6070614,20.1739164 C21.1992241,20.1739164 20.8692188,19.8424156 20.8699677,19.4368778 L20.8765772,15.8579411 Z M22.3432458,18.6992772 L25.4631368,18.6992772 C26.2771848,18.6992772 26.5082218,19.1985848 25.976314,19.8178398 L19.3606894,27.5198476 C18.5646476,28.4466112 17.9193282,28.2102165 17.9193282,26.9842419 L17.9193282,22.3858752 L14.7994372,22.3858752 C13.9853892,22.3858752 13.7543522,21.8865676 14.28626,21.2673127 L20.9018846,13.5653049 C21.6979264,12.6385413 22.3432458,12.874936 22.3432458,14.1009106 L22.3432458,18.6992772 Z" id="Combined-Shape"></path>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconBolt extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}


